import React from "react";
import { Button } from "@a365/dsys";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

const SocialNetwork = () => {
  const { t, i18n } = useTranslation();

  const geoUrl = location.pathname.split("/")[1] || "ar";
  const isBR =
    geoUrl === "br" ||
    geoUrl === "pt" ||
    localStorage.getItem("lang") === "pt" ||
    i18n.language === "pt-BR";

  const ASSETS_URL =
    "https://assistcdn.s3.us-west-1.amazonaws.com/assets/site/icons";

  const _options = [
    {
      text: "Instagram",
      link: isBR
        ? "https://www.instagram.com/assist365br/"
        : "https://www.instagram.com/assist365ok/",
      icon: <img src={`${ASSETS_URL}/InstagramLogo.svg`} alt="Instagram" />,
    },
    {
      text: "Facebook",
      link: isBR
        ? "https://www.facebook.com/segurodeviagemassist365/"
        : "https://www.facebook.com/assist.365.cover/",
      icon: <img src={`${ASSETS_URL}/FacebookLogo.svg`} alt="Facebook" />,
    },
    {
      text: "X",
      link: "https://twitter.com/assist365ok",
      icon: <img src={`${ASSETS_URL}/XLogo.svg`} alt="X" />,
    },
    {
      text: "TikTok",
      link: "https://www.tiktok.com/@assist365ok",
      icon: <img src={`${ASSETS_URL}/TiktokLogo.svg`} alt="TikTok" />,
    },
    {
      text: "LinkEdin",
      link: "https://ar.linkedin.com/company/assist-365",
      icon: <img src={`${ASSETS_URL}/LinkedinLogo.svg`} alt="LinkEdin" />,
    },
    {
      text: "Youtube",
      link: isBR
        ? "https://www.youtube.com/@assist365br/featured"
        : "https://www.youtube.com/c/Assist365_Seguro_de_viaje",
      icon: <img src={`${ASSETS_URL}/YoutubeLogo.svg`} alt="Youtube" />,
    },
  ];

  const goTo = (url) => {
    window.open(url, "_blank");
  };

  const options = _options.map((option, index) => {
    if (isBR && ["X", "LinkEdin", "TikTok"].includes(option.text)) {
      return null;
    }

    return (
      <li key={index}>
        <Button variant="default" color="secondary" mode="icon" size="small" onClick={() => goTo(option.link)}>
          {option.icon}
        </Button>
      </li>
    );
  });

  return (
    <div className="social-network-container">
      <span className="text-text-decorative-darker font-semibold text-base pb-4">
        {t("follow")}
      </span>
      <ul className="flex space-x-2 mt-4">
        {options}
      </ul>
    </div>
  );
};

export default SocialNetwork;